<template>
  <div>
    <el-form role="form" @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-6">
          <base-input label="Name" v-model="expenseType.label" v-uppercase></base-input>
        </div>
      </div>
      <base-button md type="primary" native-type="submit">Save</base-button>
    </el-form>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { Form } from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  data: () => {
    return {};
  },
  computed: {
    ...mapState("expenseType", ["expenseType"]),
    ...mapGetters({
      expenseType: "expense/getExpenseType",
      user: "user/getLoggedInUser"
    })
  },
  components: {
    [Form.name]: Form
  },
  methods: {
    ...mapActions({
      saveExpenseType: "expense/saveExpenseType",
      updateExpenseType: "expense/updateExpenseType",
      getExpenseTypes: "expense/getExpenseTypes"
    }),
    onSubmit() {
      if (this.expenseType.expenseTypeId) {
        this.updateExpenseType().then(res => {
          this.$notify({
            message: "Expense type Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.getExpenseTypes();
          this.$emit("close");
        });
      } else {
        this.expenseType.createdBy = this.user.userId;
        this.saveExpenseType().then(res => {
          this.$notify({
            message: "Expense type Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getExpenseTypes();
          this.$emit("close");
        });
      }
    }
  }
};
</script>